import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Row } from "react-bootstrap";

import * as Template from "../../templates";
import * as actions from "../../actions";
import { useNavigate, useParams } from "react-router-dom";

export default (props) => {
  const moduleName = `periodics`;
  const appReducer = useSelector((state) => state.appReducer, shallowEqual);
  const dispatch = useDispatch();

  const params = useParams()

  const navigate = useNavigate()

  const [id, setId] = useState();

  const [name, setName] = useState(``);
  const [state, setState] = useState(``);
  const [hour, setHour] = useState(``);
  const [message, setMessage] = useState(``);
  const [templateId, setTemplateId] = useState(``);
  const [submitted, setSubmitted] = useState(false);

  const handleChangeState = (value) => setState(value);
  const handleClick = () => {
    if (id != undefined) {
      dispatch(actions.update(id, moduleName));
    } else {
      dispatch(actions.store(moduleName));
    }
    setSubmitted(true)
  };

  useEffect(() => {
    if( submitted ){
        if( 
          (appReducer.periodics_store != undefined && appReducer.periodics_store.error == false) || 
          (appReducer.periodics_update != undefined && appReducer.periodics_update.error == false) 
        ){
            navigate(-1)
        }
    }
    return () => setSubmitted(false)
  }, [
    appReducer.periodics_store,
    appReducer.periodics_update
  ])

  useEffect(() => {
    if (appReducer.periodics_edit != undefined && id != undefined) {
      
      let row = appReducer.periodics_edit.data;
      
      setName(row.name)
      setHour(row.hour);
      setMessage(row.message);
      setTemplateId(row.template_id);

      let invoiceState = "در حال بررسی"

      switch (row.state) {
        case "cancelled":
          invoiceState = "لغو شده"
          break;
        case "preview":
          invoiceState = "پیش‌ فاکتور"
          break;
        case "waiting":
          invoiceState = "در حال بررسی"
          break;
        case "accept":
          invoiceState = "تایید شده"
          break;
        case "trash":
          invoiceState = "زباله‌دان"
          break;
        case "packaging":
          invoiceState = "بسته‌بندی"
          break;
        case "stopped":
          invoiceState = "متوقف‌شده"
          break;
        case "preparation":
          invoiceState = "آماده‌سازی"
          break;
        case "ready_to_send":
          invoiceState = "آماده ارسال"
          break;
        case "peyk":
          invoiceState = "تحویل پیک"
          break;
        case "sent":
          invoiceState = "ارسال شده"
          break;
        case "post":
          invoiceState = "تحویل اداره پست"
          break;
        case "delivered":
          invoiceState = "پایان مراحل"
          break;
        case "customer_blocked":
          invoiceState = "عدم پاسخگویی"
          break;
        case "considering":
          invoiceState = "بررسی بیشتر"
          break;
      }

      setState({
        value: row.state,
        label: invoiceState,
      })

    }
  }, [appReducer.periodics_edit]);


  useEffect(() => {
    if (id != undefined) {
      dispatch(actions.edit(id, moduleName));
    }
  }, [id]);

  useEffect(() => {
    if (params.id != undefined) {
      setId(params.id)
    }
  }, [params])

  return (
    <Row>
      <Template.Card col="col-md-6 col-xs-12 col-sm-12" title={props.page}>
        <Template.Form>
          <Template.Input required value={name} label="نام" name="name" type="text" />
          <Template.Input required value={templateId} label="شناسه قالب" name="template_id" type="text" />
          <Template.Input required value={hour} label="زمان بعد از خرید کاربر" name="hour" type="text" />
          <Template.Textarea  required value={message} label="پیام" name="message" />
          <Template.SingleSelect
            required
            withLabel
            placeholder="وضعیت"
            onChange={handleChangeState}
            name="state"
            value={state}
            options={[
              {
                value: "accept",
                label: "تایید‌شده",
              },
              {
                value: "preview",
                label: "پیش‌ فاکتور",
              },
              {
                value: "cancelled",
                label: "لغوشده",
              },
              {
                value: "waiting",
                label: "در حال بررسی",
              },
              {
                value: "trash",
                label: "زباله‌دان",
              },
              {
                value: "packaging",
                label: "بسته‌بندی",
              },
              {
                value: "peyk",
                label: "تحویل پیک",
              },
              {
                value: "preparation",
                label: "آماده‌سازی",
              },
              {
                value: "ready_to_send",
                label: "آماده ارسال",
              },
              {
                value: "considering",
                label: "بررسی بیشتر",
              },
              {
                value: "sent",
                label: "ارسال‌شده",
              },
              {
                value: "post",
                label: "تحویل اداره پست",
              },
              {
                value: "stopped",
                label: "متوقف شده",
              },
              {
                value: "delivered",
                label: "پایان مراحل",
              },
              {
                value: "customer_blocked",
                label: "عدم پاسخگویی",
              },
            ]}
          />
          <Template.Button
            label="ذخیره"
            
            onClick={handleClick}
          />
        </Template.Form>
      </Template.Card>
    </Row>
  );
};